import React from 'react';
import { Link } from 'react-router-dom';
import {
  Phone,
  Envelope,
  MapPin,
  FacebookLogo,
  TwitterLogo,
  InstagramLogo
} from '@phosphor-icons/react';

const PublicFooter = () => {
  return (
    <footer className="bg-white py-12 border-t border-gray-200" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-8 items-start mb-8">
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-gray-500 mt-1 flex-shrink-0" />
              <p className="text-gray-700">Office no. 555, 5th Floor, 288 on Kent, 288 Kent Avenue, Ferndale, Randburg, Gauteng, 2194</p>
            </div>
            <div className="flex items-center gap-2">
              <Envelope className="w-4 h-4 text-gray-500 flex-shrink-0" />
              <a href="mailto:info@maremaconsulting.co.za" className="text-gray-700 hover:text-[#4CAF50] transition-colors" data-testid="footer-email-link">
                info@maremaconsulting.co.za
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-gray-500 flex-shrink-0" />
              <a href="tel:+27105009477" className="text-gray-700 hover:text-[#4CAF50] transition-colors" data-testid="footer-phone-link">
                +27 10 500 9477
              </a>
            </div>
          </div>
          <div className="md:text-right">
            <nav className="flex flex-wrap gap-4 md:justify-end mb-4">
              <Link to="/cookies-policy" className="text-gray-600 hover:text-[#4CAF50] text-sm" data-testid="footer-cookies-link">Cookies</Link>
              <Link to="/disclaimer" className="text-gray-600 hover:text-[#4CAF50] text-sm" data-testid="footer-disclaimer-link">Disclaimer</Link>
              <Link to="/paia-manual" className="text-gray-600 hover:text-[#4CAF50] text-sm" data-testid="footer-paia-link">PAIA Manual</Link>
              <Link to="/privacy-policy" className="text-gray-600 hover:text-[#4CAF50] text-sm" data-testid="footer-privacy-link">Privacy Policy</Link>
              <Link to="/terms-and-conditions" className="text-gray-600 hover:text-[#4CAF50] text-sm" data-testid="footer-terms-link">Terms and Conditions</Link>
              <Link to="/login" className="text-gray-600 hover:text-[#4CAF50] text-sm" data-testid="footer-admin-link">Admin Portal</Link>
            </nav>
            <div className="flex gap-3 md:justify-end">
              <a href="https://x.com/MaremaConsult" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600">
                <TwitterLogo className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100071103276334" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600">
                <FacebookLogo className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/maremaconsulting/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600">
                <InstagramLogo className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 text-center">
          <p className="text-gray-500 text-sm">Copyright &copy; {new Date().getFullYear()} Marema Consulting | Powered by Marema Consulting</p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
